import Vue from "vue";
import MacAddress from "@/components/elements/macAddress";
import DniSelect from "@/components/elements/dniSelect";
import DniCheckbox from "@/components/elements/dniCheckbox";
import DniRadio from "@/components/elements/dniRadio";
import IpAddress from "@/components/elements/ipAddress";
import Ipv6Address from "@/components/elements/ipv6Address";
import Password from "@/components/elements/password";
import DPassword from "@/components/elements/dPassword";
import FormButtons from "@/components/form/formButtons";
import HelpBar from "@/components/form/helpBar";
import RadioGroup from "@/components/form/radioGroup";
import TableButtons from "@/components/tableButtons";
import PasswordValidation from "@/components/form/passwordValidation";
import CountryGroup from "@/components/elements/countryGroup";
import CountryRadio from "@/components/elements/countryRadio";
import HelpDhcp from "@/components/form/helpDhcp";

Vue.component("MacAddress", MacAddress);
Vue.component("DniSelect", DniSelect);
Vue.component("DniCheckbox", DniCheckbox);
Vue.component("DniRadio", DniRadio);
Vue.component("IpAddress", IpAddress);
Vue.component("Ipv6Address", Ipv6Address);
Vue.component("Password", Password);
Vue.component("DPassword", DPassword);
Vue.component("FormButtons", FormButtons);
Vue.component("HelpBar", HelpBar);
Vue.component("RadioGroup", RadioGroup);
Vue.component("TableButtons", TableButtons);
Vue.component("PasswordValidation", PasswordValidation);
Vue.component("CountryGroup", CountryGroup);
Vue.component("CountryRadio", CountryRadio);
Vue.component("HelpDhcp", HelpDhcp);
